import React from "react";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemNoWithCopy } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNoWithCopy/ItemNoWithCopy";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useTranslation } from "@coworker/locales";
import FurnitureSetIconPath from "@ingka/ssr-icon/paths/furniture-set";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import styles from "../../../styles/common-styles.module.css";

interface ItemCardWithCopyNoLocalCombinationProps {
  item: Item & { quantity?: number };
  onCopy?: () => void;
}

export const ItemCardWithCopyNoLocalCombination = ({
  item,
  onCopy,
}: ItemCardWithCopyNoLocalCombinationProps) => {
  const { t } = useTranslation();

  return (
    <ItemCard>
      <div className={styles["item-card-root-row"]}>
        <ItemImage imageUrl={""} fallbackImageIcon={FurnitureSetIconPath} />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          <ItemNoWithCopy itemNo={item.noFormatted} onCopy={onCopy} />
          {item.quantity && (
            <FixaText textStyle="Body.M">
              <strong>
                {t("piecesCountString", { count: item.quantity })}
              </strong>
            </FixaText>
          )}
        </div>
      </div>
    </ItemCard>
  );
};
